export const DEFAULT_MAX_FILES = 10;
export const MAX_FILE_SIZE_BYTES = 3 * 1024 * 1024; // 3 MB
export const PDF_ACCEPT = { 'application/pdf': ['.pdf'] };
